import factory from './icon';
import Svg from './glyphs/phone-call.svg';

export default factory(Svg);
